import React, { Component } from 'react';

import '../../style/DeleteProjectDialog.scss';
import queries from '../../queries';
import { apolloClient } from '../../config';
import { showToast } from '../../toast';
import { t } from '../../i18n';

// Suppression définitive d'une interface : il faut retaper son nom pour confirmer.
// Ouverture : window.dispatchEvent(new CustomEvent('tsk-delete-project', { detail: { id, name } }))
class DeleteProjectDialog extends Component {

  state = { open: false, id: null, name: '', typed: '', busy: false };

  componentDidMount() {
    window.addEventListener('tsk-delete-project', this.open);
    window.addEventListener('keydown', this.onKey);
  }

  componentWillUnmount() {
    window.removeEventListener('tsk-delete-project', this.open);
    window.removeEventListener('keydown', this.onKey);
  }

  onKey = (e) => { if (e.key === 'Escape' && this.state.open && !this.state.busy) this.close(); };
  open = (e) => this.setState({ open: true, typed: '', busy: false, ...e.detail });
  close = () => this.setState({ open: false });

  submit = async () => {
    const { id, name } = this.state;
    this.setState({ busy: true });
    try {
      await apolloClient.mutate({
        mutation: queries.projects.del,
        variables: { input: id },
        refetchQueries: () => [{ query: queries.projects.list }, { query: queries.projects.archived }],
      });
      showToast(t('ui.del.done', { name }), 'info');
      this.close();
      window.dispatchEvent(new CustomEvent('tsk-project-deleted', { detail: { id } }));
    } catch (e) {
      this.setState({ busy: false });
      showToast(t('ui.del.fail'), 'error', 7000);
    }
  };

  render() {
    const { open, name, typed, busy } = this.state;
    if (!open) return null;
    const matches = typed.trim() === (name || '').trim();
    return (
      <div className='tsk-ui-modal-overlay' onMouseDown={() => !busy && this.close()}>
        <div className='tsk-ui-modal-surface tsk-deleteproject' role='alertdialog' aria-label={t('ui.del.title', { name })} onMouseDown={(e) => e.stopPropagation()}>
          <h3 className='tsk-ui-modal__title'>{t('ui.del.title', { name })}</h3>
          <div className='tsk-deleteproject__warn'>
            {t('ui.del.warn')}
            <ul>
              <li>{t('ui.del.note1')}</li>
              <li>{t('ui.del.note2')}</li>
            </ul>
          </div>
          <label className='tsk-deleteproject__field'>
            <span>{t('ui.del.type', { name })}</span>
            <input type='text' autoFocus value={typed} onChange={(e) => this.setState({ typed: e.target.value })} placeholder={name} />
          </label>
          <div className='tsk-ui-modal__actions'>
            <button type='button' className='tsk-button' style={{ background: 'transparent', color: 'inherit', boxShadow: 'none', border: '1px solid var(--tsk-border)' }} disabled={busy} onClick={this.close}>{t('ui.common.cancel')}</button>
            <button type='button' className='tsk-button tsk-warning' disabled={!matches || busy} onClick={this.submit}>
              {busy ? t('ui.del.deleting') : t('ui.del.confirm')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default DeleteProjectDialog;
